import { useEffect, useRef, useState } from "react";

import abortableFetch from "../../../../helpers/abortableFetch";

type TCachedResult = { [key: string]: any };

interface IUseMakeRequestByURL {
  onSearch: (searchResult: string | TCachedResult) => void;
  getRequestURL: (query: string) => string;
  onProcessResponse: (resp: any) => any;
  searchString: string;
  originalSearchText: string;
}

const useMakeRequestByURL = ({
  onSearch,
  getRequestURL,
  onProcessResponse,
  searchString,
  originalSearchText,
}: IUseMakeRequestByURL) => {
  const abortedRef = useRef({ onAbort: () => {} });
  const [cachedResults, setCachedResults] = useState<TCachedResult>({});

  useEffect(() => {
    (async () => {
      if (!searchString) return;

      const reqURL = getRequestURL(searchString);

      if (!reqURL) {
        onSearch(searchString);
        return;
      } else if (cachedResults[searchString]) {
        onSearch(onProcessResponse(cachedResults[searchString]));
        return;
      }

      const { abort, ready } = abortableFetch(reqURL);

      abortedRef.current.onAbort = abort;

      try {
        const resp = await ready;
        const body = await resp.json();

        onSearch(onProcessResponse(body));
        setCachedResults((cache) => ({ ...cache, [searchString]: body }));
      } catch (err) {
        /** check does current req was aborted err.name == "AbortError" */
      }
    })();
  }, [searchString]);

  useEffect(() => {
    // cancel previous request while user start type anything
    abortedRef.current.onAbort?.();
  }, [originalSearchText]);
};

export default useMakeRequestByURL;
